import { TabPanel } from "primereact/tabview";
import * as React from "react";
import "./PrwcTabPanel.scss";

const PrwcTabPanel = (props: any) => {

  const {children, ...restProps} = props;

  return <TabPanel {...restProps}>{children}</TabPanel>;
};

export default PrwcTabPanel;
